export default __webpack_public_path__ + "static/media/erisa.335e235b.png";